define('AwaLabs.AllBrands', [
    'AllBrands.View',
    'Facets.Helper',
    'Facets.Router',
    'Categories',
    'Backbone',
    'jQuery',
    'Utils',
    'underscore'
], function AwaLabsAllBrands(
    AllBrandsView,
    FacetsHelper,
    FacetsRouter,
    Categories,
    Backbone,
    jQuery,
    Utils,
    _
) {
    'use strict';

    var application;
    var brandConfig;
    var depthRouteLeves = function depthRouteLeves() {
        var depth = (brandConfig.depthLevels) ? parseInt(brandConfig.depthLevels, 10) : 3;
        var urls = [];
        var prefix = ':url/';
        var url = brandConfig.pageUrl;
        var i;

        for (i = 0; i < depth; i++) {
            url = prefix + url;
            urls.push(
                url,
                url + '/'
            );
        }

        return urls;
    };
    var registerPageType = function registerPageTypeFn() {
        var pageTypeComponent = application.getComponent('PageType');
        var url = depthRouteLeves();
        pageTypeComponent.registerPageType({
            name: 'brands',
            routes: url,
            view: AllBrandsView
        });
    };

    // Workaround to register router handles after facets and categories.
    _.extend(FacetsRouter.prototype, {
        addUrl: _.wrap(FacetsRouter.prototype.addUrl, function addUrlWrap(fn, urls, functionToCall) {
            var results = fn.apply(this, _.toArray(arguments).slice(1));
            if (functionToCall === 'categoryLoading') {
                registerPageType();
            }
            return results;
        })
    });

    return {
        environment: null,
        getUrlWithoutBrands: function getCategoryUrl() {
            var fragment = Backbone.history.fragment;
            var paths;
            var categoryPaths;

            fragment = fragment.split('?')[0];
            paths = _.compact(fragment.split('/'));
            categoryPaths = _.reject(paths, function reject(path) {
                return path === brandConfig.pageUrl;
            });

            return categoryPaths.join('/');
        },
        isCategory: function isCategory() {
            var url = this.getUrlWithoutBrands();
            var topLevel = Categories.getTopLevelCategoriesUrlComponent();
            var categoryTopLevelUrl;
            var categoryUrl;

            return !!_.find(topLevel, function find(topLevelUrl) {
                categoryTopLevelUrl = Utils.correctURL(topLevelUrl);
                categoryUrl = Utils.correctURL(url);
                return categoryUrl.indexOf(categoryTopLevelUrl) === 0;
            });
        },
        mountToApp: function mountToApp(container) {
            var self = this;
            var layout = container.getComponent('Layout');
            this.environment = container.getComponent('Environment');
            application = container;
            brandConfig = this.environment.getConfig('AllBrands') || {};

            if (layout) {
                layout.addToViewContextDefinition('Facets.FacetedNavigationItem.View', 'isBrandFacet', 'boolean', function isBrandFacet(context) {
                    var isCategory = self.isCategory();
                    return (context.facetId === brandConfig.facetId && isCategory);
                });
                layout.addToViewContextDefinition('Facets.FacetedNavigationItem.View', 'allBrandsLabel', 'string', function allBrandsLabel() {
                    var label = brandConfig.facetOptionLabel || 'View All Brands';
                    return label;
                });
                layout.addToViewContextDefinition('Facets.FacetedNavigationItem.View', 'allBrandsLink', 'string', function allBrandsLink(context) {
                    var isCategory = self.isCategory();
                    var translator = FacetsHelper.parseUrl(
                        self.getUrlWithoutBrands(),
                        container.translatorConfig,
                        isCategory
                    );
                    var brandsUrl;
                    if (context.facetId === brandConfig.facetId) {
                        brandsUrl = translator.getCategoryUrl() + '/' + brandConfig.pageUrl + '/';
                    }
                    return brandsUrl;
                });
            }
        }
    };
});
